import React from 'react';
import { connect } from 'react-redux';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import Idle from 'react-idle'

import Nav from './shared/components/nav';
import SiteHead from './shared/components/header';
import Notificaciones from './components/notificaciones/notificaciones'

import Dashboard from './views/dashboard';
import OldTickets from './views/oldtickets';
import Tickets from './views/ticket';
import Page404 from './views/errors/404';
import Reportes from './views/reportes';
import Departamentos from './views/departamentos';
import Clientes from './views/clientes';
import User from './views/user';
import Inventario from './views/inventario';
import Categorias from './views/categorias';
import Descuentos from './views/descuentoscontpaq';
import PassModal from './components/changePassword/modalPass';
import Logout from './views/signin/logout';
import Facturacion from './views/facturacion';
import Insidencias from './views/insidencias';
import InvoiceModule from './views/facturacion/invoiceModule'
import Menuf from './views/facturacion/menu';
import Eventos from './views/eventos';
import ComprasEspeciales from './views/comprasespeciales';
import Cotizaciones from './views/cotizaciones';



import * as actions from './actions/auth';

import './app.css';


global.truncar = function (sVal, nDec = 0) {
        var n = parseFloat(sVal); 
        var s = "0.00"; 
        if (!isNaN(n)){ 
         n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
         s = String(n); 
         s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
         s = s.substr(0, s.indexOf(".") + nDec + 1); 
        } 
        return s; 
    }


class App extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            navMini : true,
            passModal   : false,
        }

        this.handleClick = this.handleClick.bind(this);
        this.cerrar_menu = this.cerrar_menu.bind(this);

    }
    cerrar_menu () {
        this.setState({navMini: true})
    }

    componentDidMount() {
        let { authenticated } = this.props.auth;

        if(authenticated) {
            this.props.whoiam();
        }
    }

    toggleNav = (e) => {
        e.preventDefault();
        // console.log('abrir menu')
        this.setState({navMini: !this.state.navMini});
    }

    hideNav = (e) => {
        e.stopPropagation();
        e.preventDefault();
        // console.log('cerrar al dar click en div negro ')
        this.setState({navMini: true})
    }

    handleClick() {
        this.props.signout();
    }

    toggleChangePass = (e) =>{
        this.setState({
            passModal: !this.state.passModal,
        });
    }

    push_menu = (e) =>{
        this.props.history.push('app/facturacion/proveedores');
    }


    render() {

        let navMini = this.state.navMini;
        // console.log('navMini----->',navMini)

        let {authenticated, user,permisos} = this.props.auth;
       // console.log('tamaño',window.screen.height)
        if(!authenticated)
            return (<Redirect to={{pathname: '/'}} />);

        return (


               <Idle
                  //30 min
                  timeout={1800000}
                  //5 min
                 //timeout={300000}
                render={({ idle }) =>
                  <HashRouter basename='app'>
                    {(idle)
                      ? <Logout inactivo={idle} onClick={this.handleClick}/>
                      : 
                <div className="app-wrapper">
               


                    <Notificaciones/>
                   

                    <div className={`content-container  ${navMini ? 'full' : ''}`}>

                     <Nav mini={navMini} props={this.props} toggleNav={this.toggleNav} ocultar={this.cerrar_menu} user={user} permisos={permisos} />
                       
                        <div 
                         className="menu-dropshadow " 
                         style={{display: (navMini ? 'none': 'block')}} 
                         onClick={this.hideNav}></div>
                        
                        <SiteHead toggleNav={this.toggleNav} onClick={this.handleClick} props={this.props} ocultar={this.cerrar_menu}  inactivo={idle} user={user} permisos={permisos} history_push={this.push_menu} ChangePass={this.toggleChangePass} />
                         
                        <Switch>
                            <Route exact path="/" component={Dashboard} />
                            <Route path="/old_tickets" component={OldTickets} />
                            <Route path="/tickets" component={Tickets} />
                            <Route path="/insidencias" component={Insidencias} />
                            <Route path="/reportes" component={Reportes} />
                            <Route path="/departamentos" component={Departamentos} />
                            <Route path="/clientes" component={Clientes} />
                            <Route path="/usuarios" component={User} />
                            <Route path="/inventario" component={Inventario} />
                            <Route path="/categorias" component={Categorias} />
                            <Route path="/descuentos" component={Descuentos} />
                            <Route path="/facturacion" component={Facturacion} />
                            <Route path="/invoiceModule" component={InvoiceModule}/>
                            <Route path="/eventos" component={Eventos}/>
                            <Route path="/ComprasEspeciales" component={ComprasEspeciales}/>
                            <Route path="/cotizaciones" component={Cotizaciones}/>
                            <Route component={Page404} />
                        </Switch>

                    </div>
                    <PassModal
                        open2={this.state.passModal}
                        toggleE={this.toggleChangePass}
                    />
                </div>
           
                    }
                   </HashRouter>
                }
              />
          

            
        );

    }
};

function mapStateToProps(state, ownProps) {
    return {
        auth : state.auth
    }
}

export default connect(mapStateToProps, actions)(App);





// WEBPACK FOOTER //
// ./src/App.js